module.exports = __webpack_public_path__ + "static/img/anxunMobel12.87e7d796.png";